import { TbBrandCashapp, TbTruckDelivery, TbUserCog } from 'react-icons/tb';
import { IconSetCategory, IconSetType } from '../../../../../../sheet/types';
import { BiError } from 'react-icons/bi';
import { MdOutlinePriorityHigh, MdPayments } from 'react-icons/md';
import { FcHighPriority } from 'react-icons/fc';
import { useRef } from 'react';
import Picker1 from '../../../../../../core/components/pickers/Picker1';
import { UpdateRule } from '../useCreateDataValidation';
import { IoMdRainy } from 'react-icons/io';
import { FaRegStar } from 'react-icons/fa';

interface IconSetPickerProps {
  category: IconSetCategory;
  // useCustomIcons?: boolean;
  updateRule: UpdateRule;
}
const IconSetPicker = ({ category, updateRule }: IconSetPickerProps) => {
  const options = getIconSetOptions();
  const selectedRef = useRef<HTMLButtonElement | null>(null);

  const changeCategory = (category: IconSetCategory) => {
    let customIcons = false;
    if (category === IconSetCategory.Custom) {
      customIcons = true;
    }
    const { setType } = getCategoryIcon(category);
    updateRule({ category, useCustomIcons: customIcons, setType });
  };

  const { Icon } = getCategoryIcon(category);

  const menu = (
    <Picker1.Menu ref={selectedRef}>
      <Picker1.MenuButton Icon={<Icon />} title={category} />
      <Picker1.MenuList
        selectedRef={selectedRef}
        selectedValue={category}
        optionsWithIcons={options}
        changeValue={changeCategory}
      />
    </Picker1.Menu>
  );

  return menu;
};

// #region helpers
const getIconSetOptions = () =>
  Object.values(IconSetCategory).map((name) => ({
    name,
    ...getCategoryIcon(name),
  }));



const getCategoryIcon = (name: string) => {
  let Icon = BiError;
  let setType = IconSetType.Single;

  switch (name) {
    case IconSetCategory.Delivery:
      Icon = TbTruckDelivery;
      break;
    case IconSetCategory.PaymentInflow:
      Icon = MdPayments;
      break;
    // case IconSetCategory.PaymentOutflow:
    //   Icon = TbBrandCashapp;
    //   break;
    case IconSetCategory.Rating:
      Icon = FaRegStar;
      setType = IconSetType.Progressive;
      break;
    case IconSetCategory.Priority:
      Icon = MdOutlinePriorityHigh;
      break;
    case IconSetCategory.Weather:
      Icon = IoMdRainy;
      break;
    case IconSetCategory.Custom:
      Icon = TbUserCog;
  }

  return {
    Icon,
    setType,
  };
};
// #endregion

export default IconSetPicker;
